import type { Instrument } from '@/lib/schema/types';
import { scoreSubscale, type SubscaleScoreResult } from './subscaleScore';
import type { ResponseMap } from './itemScore';

export interface TotalScoreResult {
  /** Mean of non-NA item scores across the whole instrument, or null. */
  average: number | null;
  scoredItems: number;
  naItems: number;
  pendingItems: number;
  subscales: Array<{ id: string; name: string; result: SubscaleScoreResult }>;
}

export function scoreInstrument(
  instrument: Instrument,
  responses: ResponseMap,
  itemNaMap: Record<string, boolean> = {},
): TotalScoreResult {
  let sum = 0;
  let scored = 0;
  let na = 0;
  let pending = 0;

  const subscales: TotalScoreResult['subscales'] = instrument.subscales.map(
    (s) => {
      const r = scoreSubscale(s, responses, itemNaMap);
      for (const i of r.itemResults) {
        if (i.itemNa) na += 1;
        else if (i.score != null && i.complete) {
          sum += i.score;
          scored += 1;
        } else pending += 1;
      }
      return { id: s.id, name: s.name, result: r };
    },
  );

  return {
    average: scored > 0 ? sum / scored : null,
    scoredItems: scored,
    naItems: na,
    pendingItems: pending,
    subscales,
  };
}
